import { render, staticRenderFns } from "./EcommercePage.vue?vue&type=template&id=468d2678&scoped=true&"
import script from "./EcommercePage.vue?vue&type=script&lang=ts&"
export * from "./EcommercePage.vue?vue&type=script&lang=ts&"
import style0 from "./EcommercePage.vue?vue&type=style&index=0&id=468d2678&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468d2678",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VLayout})
